<!-- Back-to-top -->
<a href="javascript:void(0)" id="back-to-top" (click)="taptotop()" [ngStyle]="{'display': show? 'block' : 'none' }">
    <i class="fe fe-arrow-up"></i>
</a>